export const defaultExpenseCurrencies = [
  { code: 'USD', symbol: '$', label: 'US Dollar' },
  { code: 'INR', symbol: '₹', label: 'Indian Rupee' },
  { code: 'EUR', symbol: '€', label: 'Euro' },
  { code: 'GBP', symbol: '£', label: 'British Pound' },
  { code: 'CNY', symbol: '¥', label: 'Chinese Yuan' },
  { code: 'CAD', symbol: 'C$', label: 'Canadian Dollar' },
  { code: 'SGD', symbol: 'S$', label: 'Singapore Dollar' },
  { code: 'JPY', symbol: '¥', label: 'Japanese Yen' },
  { code: 'KRW', symbol: '₩', label: 'South Korean Won' },
  { code: 'AUD', symbol: 'A$', label: 'Australian Dollar' },
  { code: 'CHF', symbol: 'CHF', label: 'Swiss Franc' },
  { code: 'HKD', symbol: 'HK$', label: 'Hong Kong Dollar' },
  { code: 'NZD', symbol: 'NZ$', label: 'New Zealand Dollar' },
];

export const expenseCurrencySymbolMap = defaultExpenseCurrencies.reduce((acc, currency) => {
  acc[currency.code] = currency.symbol;
  return acc;
}, {});

const expenseCurrencyAliases = defaultExpenseCurrencies.reduce((acc, currency) => {
  acc[currency.code] = currency.code;
  if (!acc[currency.symbol]) {
    acc[currency.symbol] = currency.code;
  }
  return acc;
}, {
  'C$': 'CAD',
  'S$': 'SGD',
  'A$': 'AUD',
  'HK$': 'HKD',
  'NZ$': 'NZD',
  '¥': 'CNY',
});

export const normalizeExpenseCurrencyCode = (value) => {
  const rawValue = String(value || '').trim();
  const upperValue = rawValue.toUpperCase();

  if (expenseCurrencyAliases[rawValue]) return expenseCurrencyAliases[rawValue];
  if (expenseCurrencyAliases[upperValue]) return expenseCurrencyAliases[upperValue];

  const matchedCurrency = defaultExpenseCurrencies.find((currency) =>
    upperValue.includes(currency.code)
  );

  return matchedCurrency?.code || upperValue;
};

export const toExpenseCurrencyOption = (currency) => ({
  value: currency.code,
  label: `${currency.symbol} ${currency.code} - ${currency.label}`,
  code: currency.code,
  symbol: currency.symbol,
  name: currency.label,
});
